const s = {
  name: "Network",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36,8c2.2,0,4-1.8,4-4s-1.8-4-4-4c-2.2,0-4,1.8-4,4S33.8,8,36,8z M36,2c1.1,0,2,0.9,2,2s-0.9,2-2,2
			c-1.1,0-2-0.9-2-2S34.9,2,36,2z"/>
		<path class="st0" d="M20,14c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,14,20,14z M20,24c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4
			S22.2,24,20,24z"/>
		<path class="st0" d="M0,36c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S0,38.2,0,36z M2,36c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2
			S2,34.9,2,36z"/>
		<path class="st0" d="M4,8c2.2,0,4-1.8,4-4S6.2,0,4,0S0,1.8,0,4S1.8,8,4,8z M4,2c1.1,0,2,0.9,2,2S5.1,6,4,6S2,5.1,2,4S2.9,2,4,2z"
			/>
		<path class="st0" d="M32,36c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4s-1.8,4-4,4C33.8,40,32,38.2,32,36z M34,36c0,1.1,0.9,2,2,2
			c1.1,0,2-0.9,2-2s-0.9-2-2-2C34.9,34,34,34.9,34,36z"/>
		<path class="st0" d="M13,14c0.5,0,1-0.4,1-1c0-0.5-0.5-1-1-1c-0.6,0-1,0.5-1,1C12,13.5,12.5,14,13,14z"/>
		<path class="st0" d="M8,9c0-0.6,0.5-1,1-1c0.6,0,1,0.4,1,1s-0.5,1-1,1C8.5,10,8,9.6,8,9z"/>
		<path class="st0" d="M31,10c-0.6,0-1-0.4-1-1s0.4-1,1-1c0.5,0,1,0.4,1,1S31.6,10,31,10z"/>
		<path class="st0" d="M30,31c0-0.5,0.4-1,1-1c0.5,0,1,0.5,1,1c0,0.6-0.5,1-1,1C30.5,32,30,31.5,30,31z"/>
		<path class="st0" d="M27,26c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1c0.5,0,1-0.4,1-1C28,26.4,27.6,26,27,26z"/>
		<path class="st0" d="M26,13c0-0.5,0.4-1,1-1c0.5,0,1,0.5,1,1c0,0.6-0.5,1-1,1C26.5,14,26,13.5,26,13z"/>
		<path class="st0" d="M13,26c0.5,0,1,0.5,1,1c0,0.6-0.5,1-1,1c-0.6,0-1-0.4-1-1C12,26.4,12.5,26,13,26z"/>
		<path class="st0" d="M8,31c0,0.6,0.5,1,1,1c0.6,0,1-0.4,1-1c0-0.5-0.5-1-1-1C8.5,30,8,30.4,8,31z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Network
};
